// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"64c2ed54","326":"91d0e586","433":"a9337272","754":"aa1dea59"}[chunkId] + ".chunk.css";
};